<template>
  <div class="flex justify-between" style="width: 100%;padding-top: 23px;padding-bottom: 19px;">
    <div class="flex" style="align-items: center;">
      <!-- <img src="../../assets/mbx.png" alt="" height="30" v-if="toggleSideBarHide" @click="showMenu" style="cursor: pointer;" class="mr-1" :class="[!menu_show ?'turnMenu':'']"> -->
      <!-- <span>当前位置：</span> -->
      <!-- <span class="line"></span> -->
      <el-breadcrumb  class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="(item) in levelList" :key="item.path">
            <span class="text-black" >{{ item.meta.title }}</span>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb>
    </div>
    <!-- <img src="../../assets/breadcrumb.png" alt=""> -->
  </div>
</template>

<script>
export default {
  props:{
    toggleSideBarHide:{
      type:Boolean,//侧边栏伸缩操作按钮显示隐藏
      default:false
    }
  },
  data() {
    return {
      menu_show: true,
      levelList: null
    }
  },
  watch: {
    $route(route) {
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    showMenu() {
      this.menu_show = !this.menu_show;
      this.$emit('menuShowChange',this.menu_show)
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      this.levelList = matched.filter(item => item.meta && item.meta.title)
    },
  }
}
</script>

<style lang="scss" scoped>
.line{
  display: inline-block;
  width: 6px;
  height: 20px;
  background: #FCB122;
  border: 0px solid #000000;
  border-radius: 3px;
  margin-right: 14px;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 15px;
  // line-height: 50px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
 
  img{
    margin-right: -20px;
  }
  /deep/.el-breadcrumb__inner{
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff!important;
  }
}
/deep/.el-breadcrumb__separator{
  color: #fff ;
}
.app-breadcrumb.el-breadcrumb::before,.app-breadcrumb.el-breadcrumb::after{
    display: none;
  }
.turnMenu {
  transform: rotate(180deg);
}
</style>
